import { render, staticRenderFns } from "./cunZheng.vue?vue&type=template&id=ce881012"
import script from "./cunZheng.vue?vue&type=script&lang=js"
export * from "./cunZheng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports